var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    transform: "translate(16004 1436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Select_box",
    "data-name": "Select box",
    d: "M0,0H22a8,8,0,0,1,8,8V30a0,0,0,0,1,0,0H8a8,8,0,0,1-8-8V0A0,0,0,0,1,0,0Z",
    transform: "translate(-16004 -1436)",
    fill: "#1487ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tick_icon",
    "data-name": "Tick icon",
    d: "M22.933,145.866a.8.8,0,0,1-.566-.234L20.234,143.5a.8.8,0,0,1,1.131-1.131l1.567,1.567,3.7-3.7a.8.8,0,0,1,1.131,1.131L23.5,145.632A.8.8,0,0,1,22.933,145.866Z",
    transform: "translate(-16013 -1564.047)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.eb0e57f8c194c6fc6537fe4970125c06.svg";
export { ForwardRef as ReactComponent };